import React, { Component } from 'react'
import Layout from '../../components/Layout'
import EditModal from './EditModal'
import ListTable from './ListTable'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import { cidsActions } from '../../actions'
import CrudHeader from '../../components/CrudHeader'
import { crudListStyle } from '../../styles'
import UserToolbar from '../../components/UserToolbar'

class Cids extends Component {
  state = {
    modalOpen: false
  }

  componentWillUnmount() {
    const { resetState } = this.props
    resetState()
  }

  render() {
    const { modalOpen, openModal, closeModal, newCid, classes, token } = this.props
    return (
      <Layout toolBarRight={UserToolbar}>
        <CrudHeader
          title={'CIDs'}
          classes={classes}
          newResource={newCid}
          openModal={openModal}
          closeModal={closeModal}
          token={token}
          functionality={'cids'}
        />
        <EditModal open={modalOpen} onClose={closeModal} />

        <ListTable />
      </Layout>
    )
  }
}

const mapStateToProps = state => {
  return { modalOpen: state.cids.modalOpen, token: state.auth.token }
}

const mapDispatchToProps = dispatch => {
  return {
    openModal: () => {
      dispatch(cidsActions.openModal())
    },
    closeModal: () => {
      dispatch(cidsActions.closeModal())
    },
    newCid: cid => {
      dispatch(cidsActions.newFormCid(cid))
    },
    resetState: () => {
      dispatch(cidsActions.resetState())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(crudListStyle)(Cids))



// WEBPACK FOOTER //
// ./src/containers/Cids/index.js